import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29e65061"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "registerModal",
  tabindex: "-1",
  "aria-labelledby": "registerModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog--small" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "text-center fs-7 my-3" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "socials d-flex justify-content-center align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16.001\" height=\"16\" viewBox=\"0 0 16.001 16\" data-v-29e65061><g id=\"link\" transform=\"translate(0.001 -0.003)\" data-v-29e65061><path id=\"Path_3493\" data-name=\"Path 3493\" d=\"M206.817,3.539a4.367,4.367,0,0,0-7.379-2.256l-2.07,2.07a1.069,1.069,0,0,0,1.512,1.512l2.07-2.071a2.231,2.231,0,1,1,3.155,3.156l-2.07,2.07a1.069,1.069,0,0,0,1.512,1.512l2.07-2.071a4.364,4.364,0,0,0,1.2-3.923Z\" transform=\"translate(-190.897)\" fill=\"#bbb\" data-v-29e65061></path><path id=\"Path_3494\" data-name=\"Path 3494\" d=\"M8.016,202.059,5.945,204.13a2.229,2.229,0,0,1-2,.613,2.22,2.22,0,0,1-1.15-.613,2.229,2.229,0,0,1-.49-.738,2.227,2.227,0,0,1,.49-2.418l2.071-2.07a1.069,1.069,0,0,0-1.512-1.511l-2.07,2.07a4.369,4.369,0,1,0,6.179,6.179l2.07-2.071a1.069,1.069,0,0,0-1.512-1.511Z\" transform=\"translate(0 -190.918)\" fill=\"#bbb\" data-v-29e65061></path><path id=\"Path_3495\" data-name=\"Path 3495\" d=\"M165.247,159.872a1.07,1.07,0,0,0-1.512,0l-3.891,3.891a1.069,1.069,0,0,0,1.512,1.511l3.891-3.891A1.067,1.067,0,0,0,165.247,159.872Z\" transform=\"translate(-154.546 -154.57)\" fill=\"#bbb\" data-v-29e65061></path></g></svg>", 1)
const _hoisted_12 = { class: "fs-7" }
const _hoisted_13 = { class: "modal-footer row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_14 = { class: "d-flex col-lg-12 justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { computed, ref, onMounted } from 'vue'
import { Tooltip } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    default: () => ({
      invited_code: '',
      invited_route: '',
      invited_route_name: '',
    }),
  },
},
  setup(__props) {

const props = __props



const location = computed(() => window.location)
const tooltipDiv = ref(null)
let tooltipInstance = null

onMounted(() => {
  if (tooltipDiv.value) {
    tooltipInstance = new Tooltip(tooltipDiv.value, { trigger: 'manual' })
  }
})

const showCopyTooltip = () => {
  if (!tooltipInstance || !tooltipDiv.value) return
  // Update tooltip text
  tooltipDiv.value.setAttribute('data-bs-original-title', 'コピーしました')
  tooltipInstance.show()

  // Hide tooltip after 1s
  setTimeout(() => {
    tooltipInstance.hide()
  }, 1000)
}

const CopyText = async () => {
  const copyText = document.getElementById('link')
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    let oldContentEditable = copyText.contentEditable
    let oldReadOnly = copyText.readOnly
    let range = document.createRange()

    copyText.contentEditable = true
    copyText.readOnly = false
    range.selectNodeContents(copyText)

    let s = window.getSelection()
    s.removeAllRanges()
    s.addRange(range)

    copyText.setSelectionRange(0, 999999)

    copyText.contentEditable = oldContentEditable
    copyText.readOnly = oldReadOnly

    document.execCommand('copy')
  } else {
    copyText.select()
    await navigator.clipboard.writeText(copyText.value)
  }
  showCopyTooltip()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('alumniInvitationUrl')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(__props.data.invited_route_name || __props.data.invited_route_name_default), 1),
          _createElementVNode("input", {
            type: "text",
            class: "form-control mb-4 text-link",
            id: "link",
            value: _unref(location).protocol + '//' + _unref(location).host + '/alumni/invited_communities/alumni/' + __props.data.invited_code,
            readonly: ""
          }, null, 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              ref: (_value, _refs) => {
                _refs['tooltipDiv'] = _value
                tooltipDiv.value = _value
              },
              class: "bg-gray p-2 cursor-pointer d-flex justify-content-center align-items-center button-copy",
              onClick: CopyText
            }, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(translate)('copyLink')), 1)
            ], 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})